const docLang = document.documentElement.lang;
const lang = docLang.length > 2 ? docLang.substring(0, 2) : docLang;
const labels = {
  prev: {
    de: 'Zurück blättern',
    en: 'move backwards',
  },
  next: {
    de: 'Weiter blättern',
    en: 'move forwards',
  },
  page: {
    de: 'Seite',
    en: 'Page',
  },
};

export const glideControls = `
    <div class="glide__controls" data-glide-el="controls">
        <button
          class="arrow arrow-left"
          aria-label="${labels.prev[lang]}"
          data-glide-dir="<"
          >
          <span class="icon-chevron-left" aria-hidden="true"></span>
          <span class="is-hidden">${labels.prev[lang]}}</span>
        </button>
        <button
          class="arrow arrow-right"
          aria-label="${labels.next[lang]}"
          data-glide-dir=">"
          >
          <span class="icon-chevron-right" aria-hidden="true"></span>
          <span class="is-hidden">${labels.next[lang]}</span>
        </button>
    </div>
`;

export const generateBullets = items => {
  return `
    <div class="glide__bullets" data-glide-el="controls[nav]">
    ${items
      .map((item, index) => {
        return `<button aria-label="${labels.page[lang]} ${index}" class="glide__bullet" data-glide-dir="=${index}"><span class="is-hidden">${labels.page[lang]} ${index}</span></button>`;
      })
      .join('')}
    </div>
`;
};

export const generateNumeric = slidesLength => {
  return `
    <div class="glide__numeric">
        <p class="glide__numeric-text"> <span class="glide__numeric-index">1</span>/${slidesLength}</p>
    </div>
`;
};
